import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
import generalFunc from "../Utils/generalFunc";
import {
  noNetworkMsg,
  exErrMsg,
  successMsg,
  errorMsg,
  clearMsg,
  infoMsg,
} from "../Utils/apiToasts";
// import { offline } from "../Constants/api";
// import { controller } from "../Constants/api";


const loansBaseController = "api/loan";

//===============Api for Create New Loan========================
export const createLoan = async (body) => {
    if (navigator.onLine === false) {
      noNetworkMsg();
    } else {
      try {
        const response = await api.post(`${loansBaseController}/create-loan`, body);
        if (typeof response !== "undefined") {
          if (response.status === 200) {
            toastr.success('Added New Loan', 'Success')
           
            return response.data.data;
          }
        } else {
          exErrMsg();
        }
      } catch (ex) {
        errorMsg(ex.response.data.message, "");
        throw ex
      }
    }
  }

//===============Api for Get All Loans========================
export const getAllLoans = async (params) => {
    if (navigator.onLine === false) {
        noNetworkMsg();
    } else {
      try {
        const response = await api.get(`${loansBaseController}/get-all-loans`,{params});
        if (typeof response !== "undefined") {
          if (response.status === 200) {
            // toastr.success('Get All Loans', 'Success')
            return response.data;
          }
          
        }  else {
            exErrMsg();
        }
  
      } catch (ex) {
        errorMsg(ex.response.data.message, "")
      }
    }
  }
  
// ===============Api for Activate Loan by id========================

export const activateLoans = async (id) => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.patch(`${loansBaseController}/activate-loan/${id}`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Activated Loan', 'Success')
         
          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }
      

    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}

// ===============Api for Deactivate Loan by id========================

export const deactivateLoans = async (id) => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.patch(`${loansBaseController}/deactivate-loan/${id}`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Deactivated Loan', 'Success')
         
          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }
      

    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}
  
//===============Api for Get Loan by id========================

export const getLoanById = async (id) => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${loansBaseController}/get-loan-by-id?loanId=${id}`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // toastr.success('Fetched Loan', 'Success')
         
          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }
      

    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
} 

//===============Api for Update Loan========================

export const updateLoan = async (body) => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.put(`${loansBaseController}/edit-loan`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Updated Loan', 'Success')
         
          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }
    } catch (ex) {
      if (ex.response.status === 400) {
        toastr.error(ex.response.data.message, "")
      }
      else{
      toastr.error("An Error occured", "Please try again")
    }
  }
  }
}

//===============Api for Get All Loan Total Details========================

export const getAllTotalLoanDetails = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${loansBaseController}/get-total-loans-details`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // toastr.success('Get Total Loan Details', 'Success')
          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }

    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}

//===============Api for Export Loans========================

export const exportLoans = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    // toastr.info("Downloading...", "Pending");
    await api
    .get(`${loansBaseController}/export-Loans`, {responseType: "blob"})
    .then((response) => {
      // toastr.info("Downloading...");
      if (typeof response !== "undefined") {
        if (response.status === 200 || response.status === 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `SAED Loans ${generalFunc.getCurrentYear()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          toastr.clean();
          toastr.success("Download Loans SpreadSheet", "Success");
        } else{
          toastr.clean();
          toastr.error(
            "Download Loans SpreadSheet",
            "Error in fetching API"
          );
        
        }
      }
    })
    .catch((ex) => {
      console.log(ex, "Error")
      toastr.clean();
      toastr.error("An Error occured", "Please try again");
    });
  }
};

//===============Api for Get All Loans without Pagination========================

export const getAllLoanSelect = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${loansBaseController}/get-all-loans-no-pagination`);
     /*  console.log(response) */
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // toastr.success('Get All LoanSelect', 'Success')
          return response.data.data;
        }
        
        // console.log(response)
      } else {
        toastr.error("An Error occured", "Please try again")
      }

    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}

//===============Api for Get Loan Total Beneficiary Details========================

export const getAllTotalLoanBeneficiaryDetails = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`api/LoanBeneficiary/get-total-loan-beneficiaries-details`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // toastr.success('Get Total Loan Beneficiary Details', 'Success')
          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }

    } catch (ex) {
      toastr.error("An Error occured", "Please try again")
    }
  }
}

//===============Api for Award Loan========================
export const createLoanBeneficiary = async (body) => {
  if (navigator.onLine === false) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.post(`api/LoanBeneficiary/add-corp-member-to-Loan`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Awarded Loan', 'Success')
         
          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      errorMsg(ex.response.data.message, "")
    }
  }
}

//===============Api for Get All Loan Beneficiaries to loan========================
export const getAllLBToLoan = async (id) => {
  if (navigator.onLine === false) {
      noNetworkMsg();
  } else {
    try {
      const response = await api.get(`api/LoanBeneficiary/get-all-loan-beneficiary-by-loan-no-pagination/${id}`);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // toastr.success('Get All LB To Loan', 'Success')
          return response.data;
        }
        
      }  else {
          exErrMsg();
      }

    } catch (ex) {
      errorMsg(ex.response.data.message, "")
    }
  }
}

//===============Api for Export Loans========================

export const exportLBByLoan = async (id) => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    // toastr.info("Downloading...", "Pending");
    await api
    .get(`api/LoanBeneficiary/export-loan-beneficiaries-by-loan-id?loanId=${id}`, {responseType: "blob"})
    .then((response) => {
      // toastr.info("Downloading...");
      if (typeof response !== "undefined") {
        if (response.status === 200 || response.status === 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `SAED LoanBeneficiaries by Loan ${generalFunc.getCurrentYear()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          toastr.clean();
          toastr.success("Download Loan Beneficiary by Loan SpreadSheet", "Success");
        } else{
          toastr.clean();
          toastr.error(
            "Download Loan Beneficiary by Loan SpreadSheet",
            "Error in fetching API"
          );
        }
      }
    })
    .catch((ex) => {
      console.log(ex, "Error")
      toastr.clean();
      toastr.error("An Error occured", "Please try again");
    });
  }
};

//===============Api for Download Loans Bulk Template========================

export const downloadLoanBulkTemplateApi = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    // toastr.info("Downloading...", "Pending");
    await api
    .get(`${loansBaseController}/download-loans-template`, {responseType: "blob"})
    .then((response) => {
      // toastr.info("Downloading...");
      if (typeof response !== "undefined") {
        if (response.status === 200 || response.status === 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `SAED Loans Bulk Template.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          toastr.clean();
          toastr.success("Download Loans Template", "Success");
        } else{
          toastr.clean();
          toastr.error(
            "Download Loans Template",
            "Error in fetching API"
          );
        
        }
      }
    })
    .catch((ex) => {
      console.log(ex, "Error")
      toastr.clean();
      toastr.error("An Error occured", "Please try again");
    });
  }
};

//===============Api for Create Bulk Loans========================

export const createBulkLoansApi = async (body) => {
  if (navigator.onLine === false) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.post(`${loansBaseController}/import-loans`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          toastr.success('Added Bulk Loans', 'Success')
         
          return response.data.data;
        }
      } else {
        toastr.error("An error occured")
      }
    } catch (ex) {
      errorMsg(ex.response.data.message, "")
    }
  }
}